import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import Button from '../Button';
import ShareModal from '../ShareModal';

import { hasNativeShareSupport, triggerNativeShareDialog } from '../../utils/nativeShare';

import styles from './ShareButton.module.scss';

const ShareButton = ({ title, href, type, icon, untranslatedButtonModifiers }) => {
    const { t } = useTranslation('common');
    const [shareDialogOpen, setShareDialogOpen] = useState(false);

    const buttonTitle = title || t('sharebutton.share');
    const notSsr = typeof window !== 'undefined';

    const shareTitle = notSsr ? document.title : '';

    const canonicalUrlEl = notSsr ? document.querySelector('link[rel=canonical]') : '';
    const shareUrl = href ? href : canonicalUrlEl ? canonicalUrlEl.href : notSsr ? document.location.href : '';

    const toggleShareDialog = async () => {
        if (hasNativeShareSupport() && !shareDialogOpen) {
            await triggerNativeShareDialog(shareTitle, shareUrl);

            return;
        }

        setShareDialogOpen(!shareDialogOpen);
    };

    return (
        <div className={styles['ShareButton']}>
            <div className={styles['ShareButton__Button']}>
                <Button
                    type="IsShareButton"
                    text={buttonTitle}
                    icon=""
                    onClick={toggleShareDialog}
                    untranslatedModifiers={untranslatedButtonModifiers}
                />
            </div>

            <ShareModal visible={shareDialogOpen} toggleVisible={toggleShareDialog} href={shareUrl} />
        </div>
    );
};

ShareButton.propTypes = {
    title: PropTypes.string,
    href: PropTypes.string,
    type: PropTypes.string,
    icon: PropTypes.string,
    untranslatedButtonModifiers: PropTypes.arrayOf(PropTypes.string),
};

ShareButton.defaultProps = {
    title: null,
    href: null,
    type: 'SecondarySmall',
    icon: 'Share',
    untranslatedButtonModifiers: [],
};

export default ShareButton;
